import React from 'react'
import FieldRating from "../rating"
import UI5Rating from "../../../../gd-ui/rating/rating"

type FieldRatingViewProps = {
    field       : FieldRating
    model       : any;
    className?  : string;
    options?    : any
    onClick?    : onClick
}

export default function FieldRating_View(props:FieldRatingViewProps) {
    return (
        <UI5Rating className    = {props.className}
                   scale        = {props.field.scale}
                   value        = {props.model[props.field.fieldId]}/>
    )
}
